import job from './job'
import unit from './unit'
import application from './application'
import common from './common'
import base from './base'
import dataCount from './dataCount'
import salary from './salary'

export const jobService = () => job()
export const unitService = () => unit()
export const applicationService = () => application()
export const commonService = () => common()
export const baseService = () => base()
export const dataCountService = () => dataCount()
export const salaryService = () => salary()
